import { Tooltip } from 'react-tooltip';
import { ClipboardButton } from '@/bundle/_MasterAdmin/_DevelopersPage/CreateApiKeyForm/ui/SuccessApiKeyCreatedModal/styles';
import ClipBoardIcon from '@/images/ClipBoardIcon.svg?react';

type ClipboardButtonType = {
  tooltipMessage: string;
  onClick: (message: string) => void;
};

export const ClipBoardButton = ({ tooltipMessage, onClick }: ClipboardButtonType) => {
  return (
    <>
      <Tooltip id={`${tooltipMessage}-tooltip`}>{tooltipMessage}</Tooltip>
      <ClipboardButton onClick={() => onClick(tooltipMessage)} data-tooltip-id={`${tooltipMessage}-tooltip`}>
        <ClipBoardIcon aria-label='copy url to buffer' />
      </ClipboardButton>
    </>
  );
};
